import axios from "axios";
import { useQuery } from "react-query";
import { config } from "../../../Helpers/env";
import { errorMessages } from "../../../Helpers/ErrorMessages";

/**
 * Count of ANC bookings currently marked as emergency, for the
 * "Emergency Patients" tab badge across the Gyn and Obs waiting-list pages.
 */
export function useEmergencyPatientCount(actions) {
    const { data, isSuccess } = useQuery(
        ["gynObsEmergencyPatientCount"],
        async () => {
            try {
                const response = await axios.get(
                    `${config.smsUrl}/obgyn/anc/booking/emergency_list/1`,
                    { params: { per_page: 1 } }
                );
                return response.data;
            } catch (error) {
                errorMessages(error, null, actions);
                return {};
            }
        },
        { retry: 1, staleTime: 60000 }
    );

    const emergency_count = isSuccess ? (data.total_count || 0) : 0;

    return { emergency_count };
}
